<form [formGroup]="formGroup" formFocusable>
  <app-feedback-card [originalModel]="originalModel" [formGroup]="formGroup"></app-feedback-card>

  <app-default-card
    [title]="'Interne Informationen'"
    *ngIf="authorizationService.hasRole('ROLE_EDITOR_BASE')"
    [info]="''">
    <app-internal-information [inputForm]="formGroup"></app-internal-information>
  </app-default-card>

  <app-default-card
    [title]="'Anlagenstandort'"
    [info]="'Anschrift der Anlage'"
    [errorMessage]="'Anschlussadresse ist erforderlich'">
    <app-connection-object
      [areaType]="AreaTypeEnum.POWER"
      [disable]="disableAll$ | async"
      [inputForm]="formGroup"
      (gisDataEvent)="changeGisData($event)"></app-connection-object>
  </app-default-card>

  <app-default-card
    [title]="'Anschlussnehmer (Eigentümer)'"
    [info]="
      'Name und Anschrift der natürlichen oder juristischen Person (z. B. Eigentümer), dessen Kundenanlage unmittelbar über einen Anschluss mit dem Netz des Netzbetreibers verbunden ist.'
    ">
    <!-- Hier soll eine Checkbox rein wenn der Status initial ist mit "Abweichender Anschlussnehmer" -->
    <!-- Wenn die Chekcbox angehakt ist soll das folngede Form angezeigt werden, sonst nicht.  -->
    <app-contact-form
      [formGroup]="customer"
      [connectionObjectData]="connectionObjectData$ | async"
      [differsFromCurrentUser]="
        'gridRegistration.customerMailNotInstallerMail' | uiAdaptionVisible : true
      "></app-contact-form>
  </app-default-card>

  <app-default-card
    [title]="'Anschlussnutzer (Anlagenbetreiber)'"
    [info]="
      'Name und Anschrift der natürlichen oder juristischen Person, die im Rahmen eines Anschlussnutzungsverhältnisses einen Anschluss an das Niederspannungsnetz zur allgemeinen Versorgung zur Entnahme oder Einspeisung von elektrischer Energie nutzt.'
    ">
    <form-row>
      <mat-checkbox
        formControlName="differingInvoiceContact"
        (change)="resetDifferingInvoiceContactForm($event.checked)">
        Ist der Anschlussnutzer abweichend vom Anschlussnehmer?
      </mat-checkbox>
    </form-row>
    <app-contact-form
      *ngIf="differingInvoiceContact"
      [formGroup]="invoiceContact"
      [connectionObjectData]="connectionObjectData$ | async"
      [differsFromCurrentUser]="
        'gridRegistration.customerMailNotInstallerMail' | uiAdaptionVisible : true
      "></app-contact-form>
  </app-default-card>

  <app-default-card
    *ngIf="
      formGroup &&
      formGroup.get('extractionNetworkPowerAuthorized') &&
      formGroup.get('extractionNetworkPowerAuthorized').value
    "
    [title]="'Leistungsbegrenzung'"
    [info]="''">
    <div class="col" fxFlex="40">
      <mat-form-field appearance="outline">
        <mat-label>Maximale Netzbezugsleistung (kW)</mat-label>
        <input matInput type="number" formControlName="extractionNetworkPowerAuthorized" />
      </mat-form-field>
    </div>
  </app-default-card>

  <app-default-card [title]="'Informationen zur Verbrauchseinrichtung'" [info]="''">
    <!--<form-row>
      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label>Art des Netzanschlussbegehrens</mat-label>
        <mat-select formControlName="actionType">
          <mat-option
            *ngFor="let ele of gridRegistrationService.gridRegistrationTypes$ | async"
            [value]="ele.value"
            class="select--header-and-description">
            <div>
              {{ ele.title }}
            </div>
            <div class="small">
              {{ ele.description }}
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form-row>-->

    <form-row *ngIf="isMiscRegistration">
      <mat-form-field fxFlex="50" appearance="outline">
        <mat-label>Art des Verbrauchers</mat-label>
        <input type="text" matInput required formControlName="comment" [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option
            *ngFor="let option of (miscRegistrationTypes$ | async) || []"
            [value]="option.description">
            {{ option.description }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </form-row>

    <!-- Allgemeine Info's zum Verbraucher selber. -->
    <div [formGroup]="firstConsumer">
      <form-row>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>Anzahl</mat-label>
          <input matInput type="number" min="0" formControlName="count" required />
          <mat-hint>Anzahl baugleicher {{ gridRegistrationType | gridRegistrationTypePipe }}</mat-hint>
        </mat-form-field>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>elektr. Leistung (kW)</mat-label>
          <input matInput type="number" min="0" formControlName="power" required />
          <mat-hint>
            elektr. Leistung (kW) pro {{ gridRegistrationType | gridRegistrationTypePipe }}
            {{ gridRegistrationType === GridRegistrationTypeEnum.EHeating ? 'inkl. Heizstab' : '' }}
          </mat-hint>
        </mat-form-field>
      </form-row>

      <form-row>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>Hersteller</mat-label>
          <input matInput type="text" formControlName="manufacturer" required />
        </mat-form-field>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>Typ</mat-label>
          <input matInput type="text" formControlName="deviceTypeName" />
        </mat-form-field>
      </form-row>
    </div>

    <!-- switch case for consumer specific fields -->
    <app-grid-registration-heat-pump-fields-v2
      *ngIf="gridRegistrationType === GridRegistrationTypeEnum.EHeating"
      [inputForm]="firstConsumer"></app-grid-registration-heat-pump-fields-v2>
    <!-- Felder für Ladegeräte -->
    <app-grid-registration-charger-fields-v2
      *ngIf="gridRegistrationType === GridRegistrationTypeEnum.Charger"
      [inputForm]="firstConsumer"></app-grid-registration-charger-fields-v2>

    <!-- Felder für Speicher -->
    <app-grid-registration-storage-fields-v2
      *ngIf="gridRegistrationType === GridRegistrationTypeEnum.Storage"
      [inputForm]="firstConsumer"></app-grid-registration-storage-fields-v2>

    <section>
      <app-gr-meter-number-formpart
        [formGroup]="firstConsumer"
        [hasDefiniteMeter]="false"></app-gr-meter-number-formpart>
    </section>

    <app-grid-registration-p14-formpart
      [inputForm]="firstConsumer"
      [consumerType]="originalModel.gridRegistrationType" />
  </app-default-card>

  <!-- <app-default-card
     [title]="'Messkonzept'"
     [info]="'Bitte wählen Sie hier das von Ihnen geplante Messkonzept aus.'"
     [collapsibleIsExpanded]="false"
     [isCollapsible]="true"
     [error]="errorFormList.length > 0 && !formGroup.get('meteringConcept')">
     <app-grid-registration-metering-concept
       [catalogId]='(dataShareService.tenantConfig$ | async).gridRegistration.meteringConceptCatalogId'
       [meteringConceptFormControl]="meteringConcept"></app-grid-registration-metering-concept>
   </app-default-card> -->

  <app-default-card
    *ngIf="isAreaTypeAvailableInObjectAddress && !(hideAdditionalGridConnectionPointInformationCard$ | async)"
    [title]="'Weitere Informationen zum Netzanschluss'"
    [info]="'Hier können Sie uns noch weitere wichtigen Informationen zu Ihrem Netzanschluss mitteilen'"
    [showThisComponent]="!isMiscRegistration"
    [showChildComponent]="!isMiscRegistration">
    <app-grid-registration-more-info
      [inputForm]="formGroup"
      [gridRegistrationType]="gridRegistrationType"
      [disabledAllFields]="disableAll$ | async"
      [inputFormFreeMoreInformation]="formGroup"></app-grid-registration-more-info>
  </app-default-card>

  <app-default-card [title]="'Dokumente'" [info]="''">
    <app-upload-documents
      [inputFormArray]="uploads"
      [documentTag]="'uploads'"
      [showTag]="false"
      [canUpdate]="true"
      [filterCriteria]="'equal'"
      [numberOfUploads]="10"
      [editUpload]="true"
      [showUploadButton]="true">
      <div>
        <ng-container
          *ngIf="documentsUploadInfoUIAdaptionName | uiAdaptionVisible; else defaultTechnicalDocumentsInfo">
          <div [innerHTML]="documentsUploadInfoUIAdaptionName | uiAdaptionValue | safeHtmlPipe"></div>
        </ng-container>
        <ng-template #defaultTechnicalDocumentsInfo>
          <p>
            Relevante technische Dokumentationen.
            <br />
            z.B. Datenblätter der verbauten Komponenten, Zertifikate und einen einpoligen
            Übersichtsschaltplan.
            <br />
          </p>
        </ng-template>
      </div>
    </app-upload-documents>
  </app-default-card>

  <app-default-card [title]="'Bedingungen'" [info]="''">
    <app-accept-conditions
      [inputForm]="formGroup"
      [controlName]="'acceptedConditions1'"
      [disable]="false"
      [inputLink]=""
      [inputText]="
        'Hiermit bestätige ich, dass die Zustimmung des Eigentümers vorliegt.'
      "></app-accept-conditions>
    <ng-container *ngIf="conditionsCheckboxUIAdaptionName">
      <form-row *ngIf="conditionsCheckboxUIAdaptionName | uiAdaptionVisible$ | async">
        <mat-checkbox [formControl]="customConditionsCheckbox" [disabled]="disable">
          <div [innerHTML]="conditionsCheckboxUIAdaptionName | uiAdaptionValue | safeHtmlPipe"></div>
        </mat-checkbox>
      </form-row>
      <mat-error *ngIf="customConditionsCheckbox.touched && customConditionsCheckbox.invalid">
        Bitte akzeptieren Sie alle Bedingungen
      </mat-error>
    </ng-container>
  </app-default-card>
</form>
